import { ProductType, TYPE_DIAMOND, TYPE_JEWELRY, TYPE_ROUGH } from '@/product/constants/productTypes';
export const EMPTY_COMPARISON_STATE = {
    [TYPE_DIAMOND]: [],
    [TYPE_ROUGH]: [],
    [TYPE_JEWELRY]: [],
    [ProductType.Gem]: [],
};
export const COMPARISON_LIST_STORAGE_KEY = 'comparison.list';
